<template>
  <v-card
    elevation="0"
    class="mb-4 ps-6 pb-4 user-card"
    data-tourid="add-user-invite-form"
    :class="{ active: active }"
  >
    <v-card-title class="pa-0 ma-0 mb-4">
      <div class="d-flex justify-space-between" style="width: 100%">
        <p class="text-subtitle-2 text-bold ma-0 pa-0 mt-4">
          {{ $t('people.user_information_count', { count: index }) }}
        </p>
        <v-btn
          v-if="showRemove"
          icon
          x-small
          class="mt-2 me-2"
          data-testid="userForm-button-remove"
          @click="handleRemove"
          ><v-icon size="16">mdi-close</v-icon></v-btn
        >
      </div>
    </v-card-title>
    <v-card-text class="ma-0 pa-0 pe-6">
      <div class="d-flex" :class="fullWidth ? '' : 'flex-wrap'">
        <v-text-field
          class="ma-0 pa-0 me-3"
          required
          dense
          outlined
          v-on:input="$emit('change', { displayname: $event })"
          :class="fullWidth ? 'flex-grow-0 flex-shrink-1' : ''"
          :value="account.displayname"
          :autofocus="active"
          :rules="[
            name => !!name || $t('validation.form.this_field_is_required'),
          ]"
          :placeholder="$t('onboarding.invite.required_field')"
          :label="`${$t('common.users.first_name')}*`"
          :testId="`onboardingInvite-input-firstName-${index}`"
        />
        <v-text-field
          class="ma-0 pa-0"
          required
          dense
          outlined
          :class="fullWidth ? 'flex-grow-0 flex-shrink-1 me-3' : ''"
          :value="account.familyname"
          :rules="[
            familyname =>
              !!familyname || $t('validation.form.this_field_is_required'),
          ]"
          :placeholder="$t('onboarding.invite.required_field')"
          :label="`${$t('common.users.last_name')}*`"
          :testId="`onboardingInvite-input-lastName-${index}`"
          v-on:input="$emit('change', { familyname: $event })"
        />
        <v-text-field
          class="ma-0 pa-0 me-3"
          dense
          outlined
          :class="fullWidth ? 'flex-grow-0 flex-shrink-1' : ''"
          :value="account.position"
          :label="$t('common.users.job_title')"
          :placeholder="$t('onboarding.invite.optional_field')"
          v-on:input="$emit('change', { position: $event })"
        />
        <v-text-field
          outlined
          dense
          class="ma-0 pa-0"
          placeholder="153682"
          :value="account.employeeId"
          :label="$t('profile_settings.employee_id')"
          v-on:input="$emit('change', { employeeId: $event })"
        />
        <v-text-field
          class="ma-0 pa-0"
          placeholder="name@example.com"
          required
          dense
          outlined
          :class="fullWidth ? 'flex-shrink-0 flex-grow-1' : ''"
          :error-messages="
            account.isDuplicated
              ? $t('onboarding.invite.duplicated_email_address')
              : ''
          "
          :value="account.email"
          :rules="emailRules"
          :label="`${$t('common.email_one')}*`"
          :testId="`onboardingInvite-input-email-${index}`"
          v-on:input="$emit('change', { email: $event })"
        />
      </div>
      <UserRolesSection
        data-testid="userForm-rolesSection"
        :account="account"
        :canAssignRole="canAssignRole"
        :defaultSiteId="defaultSiteId"
        :rolesEnabled="rolesEnabled"
        :siteGroups="siteGroups"
        :sites="sites"
        @change="$emit('change', $event)"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import validationHelper from '@/lib/validationHelper'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import UserRolesSection from './UserRolesSection.vue'

export default {
  name: 'UserForm',

  mixins: [trackerMixin],

  components: { UserRolesSection },

  props: {
    account: { type: Object, required: true },
    index: { type: Number, required: true },
    rolesEnabled: {
      type: Array,
      required: true,
    },
    showRemove: { type: Boolean, required: true },
    active: { type: Boolean, required: true },
    fullWidth: { type: Boolean, required: false, default: false },
    canAssignRole: {
      type: Boolean,
      required: true,
      default: false,
    },
    defaultSiteId: {
      type: String,
      required: false,
      default: '',
    },
    sites: {
      type: Array,
      default: null,
    },
    siteGroups: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      emailRules: [
        email => !!email || this.$t('validation.form.this_field_is_required'),
        email =>
          validationHelper.isValidEmailAddress(email) ||
          this.$t('onboarding.invite.invalid_email_address'),
        email =>
          !this.$constants.organization.domainsBlacklist.includes(
            this.getDomain(email)
          ) || this.$t('organization.domain_is_insecure_to_add'),
      ],
    }
  },

  methods: {
    handleRemove() {
      this.trackAddPeopleNavigate({
        element: 'removeUser',
        section: 'userForm',
      })
      this.$emit('remove')
    },

    getDomain(email) {
      return email?.replace?.(/.*@/, '') ?? ''
    },
  },
}
</script>
<style lang="scss">
.user-card {
  border: 1px solid $color-blue-grey-lighten2;
  transition: 0.2s ease;
  &:hover {
    border: 1px solid $color-blue-grey-lighten1;
    transition: 0.2s ease;
  }
  &.active {
    border: 1px solid $color-primary;
    transition: 0.2s ease;
  }
}
</style>
